import { PartnersFragmentFragment } from '../../__generated__/graphql';
import AppImage from '../../components/AppImage';
import ButtonLink from '../../components/Button/ButtonLink';
import Svg from '../../components/Svg';
import { Heading2, Heading3, Paragraph } from '../../components/Text';
import Section from '../../layout/Section';
import { ContentBlock } from '../types';

import style from './partners.module.css';

const Partners: ContentBlock<PartnersFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.partners;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <Section
      backgroundColor="white"
      id={contentBlockProps.sectionId}
      innerContainerClassName={style.container}
    >
      <div className={style.partners}>
        <div>
          <Heading2
            className={style.title}
            fontSizeOverride={36}
            fontWeight={300}
          >
            {contentBlockProps.title}
          </Heading2>

          <Paragraph fontSize={15}>
            {contentBlockProps.description}
          </Paragraph>
        </div>

        <ul className={style.partnerList}>
          {contentBlockProps.partners?.map(partner => {
            if (partner) {
              return (
                <li
                  className={style.partnerListItem}
                  key={partner.title}
                >
                  {partner.image && (
                    <AppImage
                      className={style.featuredImage}
                      fallbackHeight={300}
                      fallbackWidth={400}
                      image={partner.image}
                    />
                  )}

                  <Svg
                    containerClassName={style.partnerLogo}
                    image={partner.logo}
                  />

                  <Heading3
                    className={style.articleTitle}
                    fontSizeOverride={24}
                  >
                    {partner.title}
                  </Heading3>

                  <Paragraph
                    className={style.articleDescription}
                    fontSize={15}
                  >
                    {partner.description}
                  </Paragraph>

                  <ButtonLink
                    buttonColor="black"
                    id={partner.buttonId ?? undefined}
                    linkFragment={partner.button}
                  />
                </li>
              );
            }
          })}
        </ul>
      </div>
    </Section>
  );
};

export default Partners;
